
import EoPerson from '../EoPerson/EoPerson.vue'

export default {
  name: 'EoQuote',
  components: { EoPerson },
  props: {
    /**
     * Context: eo | lazarus | beam
     */
    context: {
      type: String,
      default: 'eo',
    },
    /**
     * The authors quote
     */
    quote: {
      type: String,
      default: null,
    },
    /**
     * The authors image
     */
    image: {
      type: String,
      default: null,
    },
    /**
     * The author of the quote
     */
    author: {
      type: String,
      default: null,
    },
    /**
     * Where the quote came from
     */
    source: {
      type: String,
      default: null,
    },
  },
  computed: {
    classes () {
      return {
        'eo-quote': true,
        ['is-context-' + this.context]: !!this.context,
      }
    },
  },
}
